export default "__VITE_ASSET__DiNKwKZ$__"